<template>
	<div style="padding: 10px;">
		<el-row :gutter="20">
			<el-col :span="7"> 
				<el-input clearable placeholder="请输入外卖柜区域" v-model="searchInfo.areaname">
					<template slot="prepend">外卖柜区域</template>
				</el-input>
			</el-col>
			<el-col :span="7">
				<el-input clearable placeholder="请输入外卖柜编码" v-model="searchInfo.cabcode">
					<template slot="prepend">外卖柜编码</template>
				</el-input>
			</el-col>
			<el-col :span="7"> 
				  <el-button type="primary" @click="searchCabs" icon="el-icon-search">搜索</el-button>
				  <el-button  icon="el-icon-refresh" @click="clearSearch">重置</el-button>
				  <el-button type="primary" icon="el-icon-plus" @click="addCabs">新增</el-button>
			</el-col>
		</el-row>
		<div style="margin-top: 10px;">
			<el-table :data="cabsList"  style="width: 100%"  height="700">
			    <el-table-column fixed="left" prop="area" label="区域" width="200" align="center"></el-table-column>
			    <el-table-column prop="address" label="位置" width="180" align="center"></el-table-column>
			    <el-table-column prop="cabtype" label="类型"  width="120" align="center"></el-table-column>
				<el-table-column prop="statename" label="状态" width="120" align="center"></el-table-column>
			    <el-table-column prop="worktime" label="工作时间" width="200" align="center"></el-table-column>
			    <el-table-column prop="cabcode" label="自有外卖柜编码" align="center"></el-table-column>
				<!-- <el-table-column prop="pic" label="图片" width="120" align="center">
					<template slot-scope="scope">
						<el-image style="width: 60px; height: 60px;border-radius: 10px;" :src="scope.row.pic" ></el-image>
					</template>
				</el-table-column> -->
				<el-table-column fixed="right" prop="op" label="操作" width="220" align="center">
					<template slot-scope="scope">
						<a @click="goFoodDetail(scope.$index, scope.row)" title="外卖柜详情" style="display:inline-block;cursor:pointer;color: #409EFF;">
							<i class="el-icon-refrigerator">详情</i>
						</a>
						<a @click="deleteCabs(scope.$index, scope.row)" title="删除外卖柜" style="cursor:pointer;margin-left: 40px;color: #F56C6C;">
							<i class="el-icon-delete">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="cabsTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashData" :destroy-on-close="false" :title="detailTitle" width="80%" :visible.sync="cabinetdetailShow">
			<CabinetDetail @needRefrash="needRefrash" :cabinfo="selectcabinet" ></CabinetDetail>
		</el-dialog>
	</div>
</template>

<script>
	//import {nfsprefix , baseUrl } from '/static/baseUrl.js'
	import { queryCabinetsList,deleteCabinet } from '/static/apiUrl.js'
	import CabinetDetail from './cabinetdetail'
	export default {
		name : 'CabsList',
		data() {
			return {
				cabinetdetailShow : false,
				editok : false,
				detailTitle : '外卖柜详情',
				selectcabinet : null,
				searchInfo:{
					areaname : '',
					cabcode : '',
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				cabsTotal : 0,
				cabsList : [],
				
			}
		},
		mounted() {
			this.initData()
			this.queryCabs()
		},
		components: {
			CabinetDetail
		},
		methods: {
			handleSizeChange(val){
				console.log(val);
				this.param.pagenum = val;
				this.queryCabs()
			},
			handleCurrentChange(val){
				console.log(val);
				this.param.page = val
				this.queryCabs()
			},
			deleteCabs(idx,row){
				console.log(idx,row)
				this.$confirm('确定将 '+row.area+row.address+' 删除?', '外卖柜删除', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let fids = [row.id]
					deleteCabinet({
						ids : fids
					}).then(res => {
						console.log(res)
						if(0 == res.code){
							this.cabsList.splice(idx,1)
							this.$message({
								type: 'success',
								message: '删除成功!'
							});
						}else{
							this.$message({
								type: 'error',
								message: res.msg
							});
						}
					})
				}).catch((err) => {
					console.log(err)
				});
			},
			initData(){
				
			},
			searchCabs(){
				this.param.page = 1
				this.queryCabs()
			},
			clearSearch(){
				this.searchInfo.cabcode = '';
				this.searchInfo.areaname = ''
				this.param.page = 1
				this.queryCabs()
			},
			queryCabs(){
				this.cabsList = []
				queryCabinetsList({
					cabcode: this.searchInfo.cabcode,
					area : this.searchInfo.areaname,
					categoryid : this.searchInfo.cabcode,
					offset : (this.param.page - 1) * this.param.pagenum,
					limit : this.param.pagenum
				}).then(res => {
					console.log(res)
					if(0 == res.code){
						this.cabsTotal = res.data.total
						res.data.data.forEach((cab ) => {
							this.cabsList.push({
								id: cab.takeawaycabinet_id,
								type : cab.takeawaycabinet_type,
								area: cab.takeawaycabinet_area,
								address : cab.takeawaycabinet_address,
								longitude : cab.takeawaycabinet_longitude,
								latitude : cab.takeawaycabinet_latitude,
								state : cab.takeawaycabinet_state,
								worktime : cab.takeawaycabinet_worktime,
								cabcode : cab.takeawaycabinet_cabcode,
								cablayout : cab.takeawaycabinet_cablayout,
								cabtype : this.getcabTypename(cab.takeawaycabinet_type),
								statename : this.getcabSatatname(cab.takeawaycabinet_state)
							})
						})
					}
				})
			},
			getcabTypename(val){
				if('self' == val){
					return "自有"
				}else if('mt' == val){
					return "美团"
				}else if('el' == val){
					return "饿了么"
				}else{
					return ''
				}
			},
			getcabSatatname(val){
				if('normal' == val){
					return "启用"
				}else if('stop' == val){
					return "停用"
				}else{
					return ''
				}
			},
			goFoodDetail(idx,row){
				this.detailTitle = '外卖柜详情'
				console.log(idx,row)
				this.selectcabinet = row
				this.cabinetdetailShow = true
			},
			addCabs(){
				this.detailTitle = "新增外卖柜"
				this.selectcabinet = null
				this.cabinetdetailShow = true
			},
			needRefrash(val){
				console.log(val)
				this.editok = val
			},
			refrashData(){
				console.log('ddd')
				if(this.editok){
					this.queryCabs()
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>